import React from "react";
import ADS from "../images/logo-applied_dynamic_solutions.png"
const Banner = () => {
  return <a href="https://www.adsworks.com/" target="_blank"><div className="absolute bottom-2 right-2 flex"><p className="text-gray-800 text-xs">Developed By:</p><img src={ADS} alt="ads works" className="w-12 ml-1"/></div></a>;
};
export default Banner;
